import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { of } from 'rxjs';
import { catchError, map, mergeMap, switchMap } from 'rxjs/operators';
import {
  CreateSiteApi,
  CreateSiteFailureApi,
  CreateSiteSuccessApi,
  DeleteSiteApi,
  DeleteSiteFailureApi,
  DeleteSiteSuccessApi,
  SiteApiActionTypes,
  LoadSiteApi,
  LoadSiteFailureApi,
  LoadSitesApi,
  LoadSitesFailureApi,
  LoadSitesSuccessApi,
  LoadSiteSuccessApi,
  UpdateSiteApi,
  UpdateSiteFailureApi,
  UpdateSiteSuccessApi,
} from './site-api.actions';
import { SiteApiService } from './site-api.service';

@Injectable()
export class SiteApiEffects {
  loadSitesApi$ = createEffect(() =>
    this.actions$.pipe(
      ofType(SiteApiActionTypes.LoadSitesApi),
      switchMap(({ payload }: LoadSitesApi) =>
        this.srv.get(payload.params).pipe(
          map((sites) => new LoadSitesSuccessApi({ sites })),
          catchError((err) => of(new LoadSitesFailureApi(err)))
        )
      )
    )
  );

  loadOneSitesApi$ = createEffect(() =>
    this.actions$.pipe(
      ofType(SiteApiActionTypes.LoadSiteApi),
      switchMap(({ payload: { id } }: LoadSiteApi) =>
        this.srv.getOne(id).pipe(
          map((site) => new LoadSiteSuccessApi({ site })),
          catchError(({ message }) => of(new LoadSiteFailureApi({ id, message })))
        )
      )
    )
  );

  createSiteApi$ = createEffect(() =>
    this.actions$.pipe(
      ofType(SiteApiActionTypes.CreateSiteApi),
      mergeMap(({ payload }: CreateSiteApi) =>
        this.srv.create(payload.site).pipe(
          map((site) => new CreateSiteSuccessApi({ site })),
          catchError((error) => of(new CreateSiteFailureApi(error)))
        )
      )
    )
  );

  updateSiteApi$ = createEffect(() =>
    this.actions$.pipe(
      ofType(SiteApiActionTypes.UpdateSiteApi),
      mergeMap(({ payload }: UpdateSiteApi) =>
        this.srv.update(payload.site).pipe(
          map((site) => new UpdateSiteSuccessApi({ site })),
          catchError((error) => of(new UpdateSiteFailureApi(error)))
        )
      )
    )
  );

  deleteSiteApi$ = createEffect(() =>
    this.actions$.pipe(
      ofType(SiteApiActionTypes.DeleteSiteApi),
      mergeMap(({ payload }: DeleteSiteApi) =>
        this.srv.delete(payload.id).pipe(
          map(({ id }) => new DeleteSiteSuccessApi({ id: payload.id })),
          catchError((err) => of(new DeleteSiteFailureApi(err)))
        )
      )
    )
  );

  constructor(private actions$: Actions, private srv: SiteApiService) {}
}
